
function evaluateUserAnswer(expectedUserInput, givenUserInput) {

    if (expectedUserInput === "") {
        return false
    }

    if (expectedUserInput === givenUserInput) {
        userInput = ""
        notifyCorrect();
        score++;
        return true;
    } else {
        userInput = ""
        return false;
    }
}


function notifyCorrect() {
    Toastify({
        text: "✅",
        duration: 1000,
        gravity: "middle",
        position: "center",

        backgroundColor: "linear-gradient(to right, #16D760, #11A349)"
        }).showToast();
}

